import Swal from 'sweetalert2';

/**
 * Muestra una alerta de éxito
 * @param {string} message - Mensaje a mostrar
 * @param {string} title - Título de la alerta (opcional)
 * @param {number} timer - Tiempo en ms antes de cerrar automáticamente (opcional)
 */
export const showSuccess = (message, title = '¡Éxito!', timer = 2000) => {
  return Swal.fire({
    icon: 'success',
    title,
    text: message,
    timer,
    showConfirmButton: timer ? false : true,
    timerProgressBar: true
  });
};

/**
 * Muestra una alerta de error
 * @param {string} message - Mensaje de error
 * @param {string} title - Título de la alerta (opcional)
 */
export const showError = (message, title = 'Error') => {
  return Swal.fire({
    icon: 'error',
    title,
    text: message,
    confirmButtonColor: '#d33'
  });
};

/**
 * Muestra un diálogo de confirmación
 * @param {string} message - Mensaje de confirmación
 * @param {string} title - Título del diálogo (opcional)
 * @param {object} options - Opciones adicionales (opcional)
 * @returns {Promise} - Promesa que resuelve con el resultado
 */
export const showConfirm = (message, title = '¿Estás seguro?', options = {}) => {
  return Swal.fire({
    icon: 'warning',
    title,
    text: message,
    showCancelButton: true,
    confirmButtonText: options.confirmButtonText || 'Sí, continuar',
    cancelButtonText: options.cancelButtonText || 'Cancelar',
    confirmButtonColor: options.confirmButtonColor || '#3085d6',
    cancelButtonColor: options.cancelButtonColor || '#d33',
    reverseButtons: true
  });
};

/**
 * Muestra una alerta de información
 * @param {string} message - Mensaje informativo
 * @param {string} title - Título de la alerta (opcional)
 */
export const showInfo = (message, title = 'Información') => {
  return Swal.fire({
    icon: 'info',
    title,
    text: message,
    confirmButtonColor: '#3085d6'
  });
};

/**
 * Muestra una alerta de advertencia
 * @param {string} message - Mensaje de advertencia
 * @param {string} title - Título de la alerta (opcional)
 */
export const showWarning = (message, title = 'Advertencia') => {
  return Swal.fire({
    icon: 'warning',
    title,
    text: message,
    confirmButtonColor: '#f39c12'
  });
};

/**
 * Muestra detalles en formato JSON
 * @param {object|string} data - Datos a mostrar
 * @param {string} title - Título de la alerta (opcional)
 */
export const showJsonDetails = (data, title = 'Detalles') => {
  const jsonString = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
  
  return Swal.fire({
    title,
    html: `<pre style="text-align: left; max-height: 400px; overflow-y: auto; background-color: #f5f5f5; padding: 1rem; border-radius: 4px; font-size: 0.9rem;">${jsonString}</pre>`,
    width: 700,
    confirmButtonColor: '#3085d6'
  });
};

/**
 * Muestra un mensaje con formato HTML personalizado
 * @param {string} html - Contenido HTML
 * @param {string} title - Título de la alerta (opcional)
 * @param {string} icon - Icono a mostrar (opcional)
 */
export const showHtml = (html, title = '', icon = null) => {
  return Swal.fire({
    icon,
    title,
    html,
    confirmButtonColor: '#3085d6'
  });
};

/**
 * Muestra un mensaje de alerta simple sin icono
 * @param {string} message - Mensaje a mostrar
 * @param {string} title - Título de la alerta (opcional)
 */
export const showAlert = (message, title = '') => {
  return Swal.fire({
    title,
    text: message,
    confirmButtonColor: '#3085d6'
  });
};
